
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import { override } from "../js/timepicker-override";
export default {
  on: {
    pageAfterOut: function () {
      window.overrideBackButton = null;
    },
    pageAfterIn: function () {
      //console.log("pageAfterIn");
      var self = this;

      window.overrideBackButton = function () {
        if (self) {
          self.slidePrevOrExit();
        } else {
          window.overrideBackButton = null;
        }
      };
    },
    pageBeforeIn: function () {
      //console.log("pageBeforeIn");
      var self = this;
      self.$setState({
        user: window.identity
      }, function () {});
    }
  },
  mounted: function () {
    //console.log("mounted");
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    self.swiper = app.swiper.create('.request-repair-swiper', {
      direction: 'horizontal',
      allowTouchMove: false,
      //effect: 'fade',
      effect: window.IS_WEBAPP ? 'slide' : 'coverflow',
      coverflowEffect: {
        rotate: 60,
        slideShadows: false,
        depth: 300
      }
    });
  },
  data: function () {
    var self = this;
    return {
      //"—"
      location: null,
      unit: null,
      problem: null,
      when: null,
      problems: {},
      whens: {},
      units: {},
      locations: {},
      user: {},
      swiper: null,
      show_contract_reminder: false,
      submit_repair_request_countdown: 0,
      edition: "english",
      available_editions: {},
      has_available_editions: false,
      translations: {},
      material_labels: {}
    };
  },
  created: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    self.$setState({
      user: window.identity
    }, function () {});
    self.loadForm();
  },
  methods: {
    loadForm() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;

      if (self.swiper) {
        self.swiper.slideTo(0, 0);
      }

      self.$setState({
        locations: {},
        whens: {},
        units: {},
        problems: {},
        location: null,
        unit: null,
        problem: null,
        when: null
      }, function () {
        app.request({
          url: Url.to("location/request-form"),
          preloader: true,
          //progress: true,
          success: function (data, status, xhr) {
            console.log(">>>>>>>>>", data);
            window.editionTranslations = data['translations'];
            self.$setState({
              show_contract_reminder: data['show_contract_reminder'],
              submit_repair_request_countdown: data['submit_repair_request_countdown'],
              locations: data['locations'],
              edition: data['edition'],
              available_editions: data['available_editions'],
              has_available_editions: Object.keys(data['available_editions']).length > 1,
              translations: data['translations'],
              material_labels: data['material_labels'],
              problems: {} //data['problems'],

            }, function () {});
            self.$tick(function () {
              self.attachListeners();
              var locationId = self.$route.params.locationId;
              var unitId = self.$route.params.unitId;

              if (locationId) {
                $$("#location-" + locationId).prop('checked', true);
                setTimeout(function () {
                  $$("#location-" + locationId).trigger('change');
                  setTimeout(function () {
                    $$("#unit-" + unitId).prop('checked', true);
                    setTimeout(function () {
                      $$("#unit-" + unitId).trigger('change');
                    }, 50);
                  }, 50);
                }, 50);
              } else {
                if (Object.keys(data['locations']).length == 1) {
                  if (Object.keys(self.locations).length === 1) {
                    self.swiper.slideTo(1, 0);
                  }

                  $$("#location-" + Object.keys(data['locations'])[0]).prop('checked', true);
                  setTimeout(function () {
                    $$("#location-" + Object.keys(data['locations'])[0]).trigger('change');
                    var loc = Object.values(data['locations'])[0];

                    if (Object.keys(loc.units).length == 1) {
                      setTimeout(function () {
                        $$("#unit-" + Object.keys(loc.units)[0]).prop('checked', true);
                        setTimeout(function () {
                          $$("#unit-" + Object.keys(loc.units)[0]).trigger('change');
                        }, 50);
                      }, 50);
                    }
                  }, 50);
                }
              }
            });
          }
        });
      });
    },

    nextSlide() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.swiper.slideNext();
    },

    prevSlide() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.swiper.slidePrev();
    },

    slidePrevOrExit() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7; //console.log(self.swiper);

      if (self.swiper.activeIndex === 0 || self.swiper.activeIndex === 1 && Object.keys(self.locations).length === 1) {
        app.views.current.router.back();
      } else {
        self.swiper.slidePrev();
      }
    },

    scanBarcode: function () {
      var self = this;
      var $$ = self.$dom7;
      cordova.plugins.barcodeScanner.scan(function (result) {
        console.log("We got a barcode\n" + "Result: " + result.text + "\n" + "Format: " + result.format + "\n" + "Cancelled: " + result.cancelled);
        var unitCode = result.text;
        var locationId = null;
        var unitId = null;
        Object.values(self.locations).forEach(function (location) {
          Object.values(location.units).forEach(function (unit) {
            if (unit.code == unitCode) {
              locationId = location.id;
              unitId = unit.id;
            }
          });
        });

        if (locationId && unitId) {
          self.$tick(function () {
            $$("#location-" + locationId).prop('checked', true);
            setTimeout(function () {
              $$("#location-" + locationId).trigger('change');
              setTimeout(function () {
                $$("#unit-" + unitId).prop('checked', true);
                setTimeout(function () {
                  $$("#unit-" + unitId).trigger('change');
                }, 50);
              }, 50);
            }, 50);
          });
        } else {
          self.$app.dialog.alert('Invalid barcode scanned, make sure to scan broken unit barcode.');
        }
      }, function (error) {
        console.log("Scanning failed: " + error);
      }, {
        preferFrontCamera: false,
        // iOS and Android
        showFlipCameraButton: false,
        // iOS and Android
        showTorchButton: false,
        // iOS and Android
        torchOn: false,
        // Android, launch with the torch switched on (if available)
        saveHistory: true,
        // Android, save scan history (default false)
        prompt: "Place a barcode inside the scan area",
        // Android
        resultDisplayDuration: 500 // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        //formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
        //orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
        //disableAnimations: true, // iOS
        //disableSuccessBeep: false // iOS and Android

      });
    },
    attachListeners: function () {
      var self = this; //console.log(self);

      var $$ = self.$dom7;
      $$('[name="location"]').on("change", function (e) {
        $$('[name="unit"]:checked').prop('checked', false);

        if (e.target.checked) {
          var checkbox = this;
          $$('[name="location"]:checked').prop('checked', false);
          $$(checkbox).prop('checked', true);
          self.$setState({
            location: self.locations[$$(checkbox).val()],
            units: self.locations[$$(checkbox).val()].units,
            problems: {},
            problem: null,
            unit: null
          }, function () {
            if (Object.keys(self.locations).length > 1) {
              setTimeout(() => {
                self.swiper.slideNext();
              }, 250);
            }

            $$("#request-confirm-location").removeClass("disabled");
            $$("#request-confirm-unit").addClass("disabled"); //self.$app.accordion.open("#request-accordion-item-unit");

            $$('[name="equipment_id"]').on("change", function (e) {
              $$('[name="schedule"]:checked').prop('checked', false);
              $$('[name="problem_id"]:checked').prop('checked', false);

              if (e.target.checked) {
                var checkbox = this;
                $$('[name="equipment_id"]:checked').prop('checked', false);
                $$(checkbox).prop('checked', true);
                self.$setState({
                  unit: self.units[$$(checkbox).val()],
                  problems: self.units[$$(checkbox).val()].problems,
                  whens: self.units[$$(checkbox).val()].whens,
                  problem: null,
                  when: null
                }, function () {
                  //Here check if there is already an active request for this equipment
                  self.checkPreviouslyActiveRequests(); //self.$app.accordion.open("#request-accordion-item-problem");

                  setTimeout(() => {
                    self.swiper.slideNext();
                  }, 250);
                  $$("#request-confirm-unit").removeClass("disabled");
                  $$("#request-confirm-problem").addClass("disabled");
                  $$('[name="problem_id"]').on("change", function (e) {
                    //console.log(e);
                    if (e.target.checked) {
                      var checkbox = this;
                      $$('[name="problem_id"]:checked').prop('checked', false);
                      $$(checkbox).prop('checked', true);
                      var problem = null;

                      if ($$(checkbox).val() == -1) {
                        problem = {
                          id: -1,
                          name: "Tell us what's happening"
                        };
                      } else {
                        problem = self.problems[$$(checkbox).val()];
                      }

                      self.$setState({
                        problem: problem
                      }, function () {
                        if (problem.id == -1) {
                          $$("#request-confirm-problem").addClass("disabled");
                          $$("#request-other-problem").val("");
                          console.log($$("#request-other-problem"));
                          $$("#request-other-problem").off("keyup");
                          $$("#request-other-problem").on("keyup", function () {
                            console.log("asdadasd");

                            if ($$("#request-other-problem").val().length >= 5) {
                              $$("#request-confirm-problem").removeClass("disabled");
                            } else {
                              $$("#request-confirm-problem").addClass("disabled");
                            }
                          });
                        } else {
                          setTimeout(() => {
                            self.swiper.slideNext();
                          }, 250);
                          $$("#request-confirm-problem").removeClass("disabled");
                          $$("#submit-request").addClass("disabled");
                        } //self.swiper.nextSlide();
                        //self.$app.accordion.open("#request-accordion-item-when");

                      });
                    } else {
                      self.$setState({
                        problem: null
                      });
                    }
                  });
                  $$('[name="schedule"]').on("change", function (e) {
                    //console.log(e, this);
                    if (e.target.checked) {
                      var checkbox = this;
                      $$('[name="schedule"]:checked').prop('checked', false);
                      $$(checkbox).prop('checked', true);
                      self.$setState({
                        when: self.whens[$$(checkbox).val()]
                      }, function () {
                        if (self.when) {
                          console.log(self.when);

                          if (parseInt(self.when.id) === 30) {
                            var dateValue = new Date(); // dateValue.setDate(dateValue.getDate() + (1 + (7 - dateValue.getDay())) % 7);

                            dateValue.setDate(dateValue.getDate() + 1);
                            dateValue.setHours(8);
                            dateValue.setMinutes(0);
                            dateValue.setSeconds(0);
                            var minDate = new Date(); // minDate.setDate(minDate.getDate() + (1 + (7 - minDate.getDay())) % 7);
                            //minDate.setDate(minDate.getDate() - 1);
                            //minDate.setDate(minDate.getDate());

                            minDate.setHours(0);
                            minDate.setMinutes(0);
                            minDate.setSeconds(0);
                            var maxDate = new Date();
                            maxDate.setDate(maxDate.getDate() + 30);

                            if (self.when.allowed_schedule) {// override.minHours = self.when.allowed_schedule['from'];
                              // override.maxHours = self.when.allowed_schedule['to'];
                            }

                            setTimeout(() => {
                              var calendarDateTime = self.$app.calendar.create({
                                inputEl: '#scheduled-calendar-date-time',
                                timePicker: true,
                                value: [dateValue],
                                minDate: minDate,
                                maxDate: maxDate,
                                closeOnSelect: false,
                                openIn: 'customModal',
                                backdrop: true,
                                closeByBackdropClick: false,
                                footer: true,
                                dateFormat: 'yyyy-mm-dd HH::mm:00' // disabled: function (date) {
                                //     if (date.getDay() === 0 || date.getDay() === 6) {
                                //         if (self.when.allowed_schedule) {
                                //             if (self.when.allowed_schedule['weekend']) {
                                //                 return false;
                                //             }
                                //         }
                                //         return true;
                                //     } else {
                                //         return false;
                                //     }
                                // },

                              });
                              calendarDateTime.openTimePicker = override.openTimePicker;
                              $$('#scheduled-calendar-date-time').attr("id", 'scheduled-calendar-date-time-tt');
                            }, 200); //$$("#submit-request").removeClass("disabled");
                          }
                        }
                      });
                    } else {
                      self.$setState({
                        when: null
                      }, function () {
                        $$("#submit-request").addClass("disabled");
                      });
                    }
                  }); //console.log(self.whens);

                  if (Object.keys(self.whens).length == 1) {
                    $$("#when-" + Object.keys(self.whens)[0]).prop('checked', true);
                    setTimeout(function () {
                      $$("#when-" + Object.keys(self.whens)[0]).trigger('change');
                    }, 50);
                  }
                });
              } else {
                self.$setState({
                  unit: null
                });
              }
            });
          }); //console.log(self.location);
        } else {
          self.$setState({
            location: null,
            units: {},
            unit: null
          });
        }
      });
    },
    checkPreviouslyActiveRequests: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      console.log(">>> checkPreviouslyActiveRequests", self.unit.id);
      self.$app.request({
        url: Url.to("repair/check-active-request"),
        method: "GET",
        data: {
          equipment_id: self.unit.id
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);

          if (data['alert']) {
            if (data['equipment_id'] == self.unit.id) {
              self.$app.dialog.create({
                title: "Mitsulift",
                content: translate(data['message']),
                verticalButtons: false,
                buttons: [{
                  text: translate('No'),
                  color: 'red',

                  onClick() {
                    self.$router.back();
                  }

                }, {
                  text: translate('Yes'),

                  onClick(dialog) {}

                }]
              }).open();
            }
          }
        }
      });
    },

    checkExtraCostAndRequest() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var extraAllowed = false;
      var extraCostAmount = "";
      var extraCostApplies = false;
      var formData = self.$app.form.convertToData("#request-repair-form");
      self.$app.request({
        url: Url.to("repair/check-extra-cost"),
        method: "POST",
        data: formData,
        success: function (data, status, xhr) {
          console.warn(data);
          extraAllowed = data['extra_allowed'];
          extraCostApplies = data['extra_cost_applies'];
          extraCostAmount = data['extra_cost_amount'];

          if (extraCostApplies) {
            if (extraAllowed) {
              self.$app.dialog.create({
                title: "Mitsulift",
                content: extraCostAmount + ' ' + window.translate('additional charge will be required for repair service request outside working hour.'),
                verticalButtons: true,
                buttons: [{
                  text: translate('Reschedule'),
                  color: 'red',

                  onClick() {
                    $$("#when-30").click();
                  }

                }, {
                  text: translate('Approve'),

                  onClick(dialog) {
                    self.$app.dialog.create({
                      title: "Mitsulift",
                      content: translate('Please confirm the additional service charge of') + ' ' + '<strong class="text-color-primary">' + extraCostAmount + '</strong>' + ' ' + translate('for your repair service request.'),
                      verticalButtons: false,
                      buttons: [{
                        text: translate('Cancel'),
                        color: 'red',

                        onClick() {}

                      }, {
                        text: translate('Ok'),

                        onClick() {
                          setTimeout(() => {
                            var milliSeconds = parseInt(self.submit_repair_request_countdown) * 1000 + 900;
                            var coutnDownDialog = self.$app.dialog.create({
                              //title: "Mitsulift",
                              content: translate('Submitting Request in') + '<br/><strong id="count-down">' + self.submit_repair_request_countdown + '</strong>s',
                              verticalButtons: true,
                              buttons: [{
                                text: translate('Cancel Request'),
                                color: 'red',

                                onClick() {
                                  clearInterval(countDownInterval);
                                  coutnDownDialog.close();
                                }

                              }],
                              on: {
                                close: function () {
                                  clearInterval(countDownInterval);
                                }
                              }
                            });
                            coutnDownDialog.open();
                            var countDownInterval = setInterval(() => {
                              milliSeconds -= 100;
                              console.warn(milliSeconds);

                              if (milliSeconds <= 0) {
                                clearInterval(countDownInterval);
                                coutnDownDialog.close();
                                self.$app.request({
                                  url: Url.to("repair/request"),
                                  method: "POST",
                                  data: formData,
                                  success: function (data, status, xhr) {
                                    self.$router.back();
                                    app.dialog.create({
                                      title: '<i class="icon material-icons color-primary" style="font-size: 48px;">check</i>',
                                      text: translate('Your service request has been sent successfully.') + '<br/><br/>' + translate('You will be receiving a call shortly in order to confirm the extra charge.'),
                                      buttons: [{
                                        text: translate('Ok')
                                      }],
                                      verticalButtons: true
                                    }).open();
                                  }
                                });
                              }

                              let secs = parseInt(milliSeconds / 1000);
                              $$("#count-down").text(secs);
                            }, 100);
                          }, 100);
                        }

                      }]
                    }).open();
                  }

                }]
              }).open();
            } else {
              self.$app.dialog.alert(translate("Additional service requests are not allowed at the moment.") + "<br/><br/>" + translate("In case of an emergency request, please call Mitsulift."));
            }
          } else {
            self.$app.dialog.create({
              title: "Mitsulift",
              content: translate('Are you sure you want to request a repair service?'),
              verticalButtons: false,
              buttons: [{
                text: translate('Cancel'),
                color: 'red',

                onClick() {}

              }, {
                text: translate('Yes'),

                onClick(dialog) {
                  setTimeout(() => {
                    var milliSeconds = parseInt(self.submit_repair_request_countdown) * 1000 + 900;
                    var coutnDownDialog = self.$app.dialog.create({
                      //title: "Mitsulift",
                      content: translate('Submitting Request in') + '<br/><strong id="count-down">' + self.submit_repair_request_countdown + '</strong>s',
                      verticalButtons: true,
                      buttons: [{
                        text: translate('Cancel Request'),
                        color: 'red',

                        onClick() {
                          clearInterval(countDownInterval);
                          coutnDownDialog.close();
                          self.$router.back();
                          app.toast.create({
                            text: translate('Request Cancelled'),
                            position: 'center',
                            closeTimeout: 2000
                          }).open();
                        }

                      }],
                      on: {
                        close: function () {
                          clearInterval(countDownInterval);
                        }
                      }
                    });
                    coutnDownDialog.open();
                    var countDownInterval = setInterval(() => {
                      milliSeconds -= 100;
                      console.warn(milliSeconds);

                      if (milliSeconds <= 0) {
                        clearInterval(countDownInterval);
                        coutnDownDialog.close();
                        self.$app.request({
                          url: Url.to("repair/request"),
                          method: "POST",
                          data: formData,
                          success: function (data, status, xhr) {
                            self.$router.back();
                            app.dialog.create({
                              title: '<i class="icon material-icons color-primary" style="font-size: 48px;">check</i>',
                              text: translate('Your repair service request has been sent successfully.'),
                              buttons: [],
                              verticalButtons: true
                            }).open();
                            setTimeout(function () {
                              app.dialog.close();
                            }, 3000);
                          }
                        });
                      }

                      let secs = parseInt(milliSeconds / 1000);
                      $$("#count-down").text(secs);
                    }, 100);
                  }, 100);
                }

              }]
            }).open();
          }
        }
      });
    },

    requestRepair: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7; //TODO: instead of checking locally if additional service required, send api request to check

      self.checkExtraCostAndRequest();
    },
    goToEditProfile: function () {
      var self = this;
      var app = self.$app;
      var view = app.views.get(".view-main");
      view.router.navigate("/edit-profile/"); //app.tab.show(".view-account", ".tab-link[href='#view-account']",false);
    },
    changeEdition: function (e) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var buttons = [];
      Object.keys(self.available_editions).forEach(edition_code => {
        var listHtml = `<div class="list no-hairlines no-margin-top"><ul style="background: transparent">`;
        listHtml += `
                    <li>
                        <a href="#" class="item-link item-content" data-country="${edition_code}" data-name="${self.available_editions[edition_code]}">
                            <div class="item-inner">
                                <div class="item-title text-color-black" style="line-height: normal;">${self.available_editions[edition_code]}</div>
                            </div>
                        </a>
                    </li>`;
        listHtml += `</ul></div>`;
        buttons.push({
          text: listHtml,

          onClick() {
            self.$app.request({
              url: Url.to("user/set-edition"),
              method: "POST",
              data: {
                edition: edition_code
              },
              success: function (data, status, xhr) {
                self.loadForm();
              }
            });
          }

        });
      });
      app.dialog.create({
        title: "Select Form Edition",
        //text: '',
        //content: fullHtml,
        verticalButtons: true,
        buttons: buttons,
        on: {}
      }).open();
    }
  },
  id: '7c5c4af225',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar navbar-extra-large" data-name="request-repair"\n         style="--f7-toolbar-height: 75px;">\n        <!-- Top Navbar -->\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a class="link icon-only" href="#" @click="slidePrevOrExit">\n                        <i class="icon icon-back "></i>\n                    </a>\n                </div>\n                <div class="title"></div>\n\n                <div class="right">\n                    <a @click="scanBarcode()" class="link icon-only display-none" href="#">\n                        <i class="icon f7-icons">qrcode_viewfinder</i>\n                    </a>\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.has_available_editions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <a @click="changeEdition" class="link icon-only" href="#">\n                        <i class="icon material-icons">language</i>\n                    </a>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n\n                        <div class="subtitle-text text-color-primary">';
      r += Template7Helpers.translate.call(ctx_1, "Request a repair", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div id="request-repair-form" class="request-repair-swiper swiper-container h-100">\n            <div class="swiper-wrapper h-100">\n                <div class="swiper-slide h-100 bg-color-white">\n                    <div class="toolbar toolbar-bottom padding-horizontal no-hairline bg-color-white">\n                        <div class="toolbar-inner">\n                            <a class="button button-large display-flex align-items-center justify-content-center back color-red" href="#"><i class="icon material-icons">close</i></a>\n\n                            <a @click="nextSlide" id="request-confirm-location"\n                               class="disabled border-rounded flex-grow-1 button button-fill button-large display-flex align-items-center justify-content-center" href="#">\n                                ';
      r += Template7Helpers.translate.call(ctx_1, "NEXT", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <i class="icon material-icons">arrow_forward</i>\n                            </a>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="block">\n                            ';
      r += Template7Helpers.js_if.call(ctx_1, "Object.keys(this.locations).length > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <h1 class="font-weight-bold no-margin-bottom" style="font-size: 2.3em;">\n                                ';
          r += Template7Helpers.translate.call(ctx_2, "In which location you want the service?", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </h1>\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            <h3 class="no-margin-top font-weight-regular text-color-gray">\n                            </h3>\n                        </div>\n                        <div class="list accordion-list no-hairlines no-hairlines-between">\n                            <ul>\n                                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.locations, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                <li>\n                                    <label class="item-checkbox item-content">\n                                        <input class="as-radio" data-label="';
          r += c(ctx_2.name, ctx_2);
          r += '" id="location-';
          r += c(ctx_2.id, ctx_2);
          r += '" name="location"\n                                               type="radio" value="';
          r += c(ctx_2.id, ctx_2);
          r += '"/>\n                                        <i class="icon icon-checkbox"></i>\n                                        <div class="item-inner">\n                                            <div class="item-title">\n                                                ';
          r += c(ctx_2.name, ctx_2);
          r += '\n                                                <div class="item-footer">\n                                                    ';
          r += c(ctx_2.address, ctx_2);
          r += '\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </label>\n                                </li>\n                                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class="swiper-slide h-100 bg-color-white">\n                    <div class="toolbar toolbar-bottom padding-horizontal no-hairline bg-color-white">\n                        <div class="toolbar-inner">\n\n                            ';
      r += Template7Helpers.js_if.call(ctx_1, "Object.keys(this.locations).length > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <a @click="prevSlide" class="button button-large display-flex align-items-center justify-content-center" href="#"><i class="icon material-icons">arrow_back</i></a>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <a class="button button-large display-flex align-items-center justify-content-center back color-red" href="#"><i class="icon material-icons">close</i></a>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                            <a @click="nextSlide" id="request-confirm-unit"\n                               class="disabled border-rounded flex-grow-1 button button-fill button-large display-flex align-items-center justify-content-center" href="#">\n                                ';
      r += Template7Helpers.translate.call(ctx_1, "NEXT", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <i class="icon material-icons">arrow_forward</i>\n                            </a>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="block">\n                            <h1 class="font-weight-bold no-margin-bottom" style="font-size: 2.3em;width: 250px">\n                                ';
      r += Template7Helpers.translate.call(ctx_1, "which unit needs support?", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            </h1>\n                            <h3 class="no-margin-top font-weight-regular text-color-gray">\n                            </h3>\n                        </div>\n                        <div class="list accordion-list no-hairlines no-hairlines-between">\n                            <ul>\n                                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.units, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                <li>\n                                    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.contract.can_request, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <label class="item-checkbox item-content">\n                                        <input data-label="';
              r += c(ctx_3.name, ctx_3);
              r += '" id="unit-';
              r += c(ctx_3.id, ctx_3);
              r += '" name="equipment_id" type="radio"\n                                               value="';
              r += c(ctx_3.id, ctx_3);
              r += '"/>\n                                        <i class="icon icon-checkbox"></i>\n                                        <div class="item-inner">\n                                            <div class="item-title">\n                                                <div class="item-header"><small>';
              r += Template7Helpers.translate.call(ctx_3, "Contract", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              r += c(ctx_2.code, ctx_3);
              r += '</small></div>\n                                                ';
              r += c(ctx_3.name, ctx_3);
              r += '\n                                                <div class="item-footer">\n                                                    ';
              r += Template7Helpers.translate.call(ctx_3, ctx_3.contract.material, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </label>\n                                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                                    <label class="item-checkbox item-content disabled">\n                                        <input name="disabled_id" type="radio"/>\n                                        <i class="icon icon-checkbox"></i>\n                                        <div class="item-inner">\n                                            <div class="item-title">\n                                                <div class="item-header">\n                                                    <small>';
              r += Template7Helpers.translate.call(ctx_3, "Contract", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              r += c(ctx_2.code, ctx_3);
              r += '</small>\n                                                </div>\n                                                ';
              r += c(ctx_3.name, ctx_3);
              r += '\n                                                <div class="item-footer text-color-red">\n                                                    ';
              r += Template7Helpers.translate.call(ctx_3, ctx_3.contract.material, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                </div>\n                                            </div>\n                                            <a class="item-link- item-content external item-after text-align-center" href="tel:';
              r += c(ctx_1.$root.phone, ctx_3);
              r += '"\n                                               target="_system">\n                                                <small style="width: 70px;white-space: normal;">\n                                                    ';
              r += Template7Helpers.translate.call(ctx_3, "Call To Reconduct", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                                                </small>\n                                            </a>\n                                        </div>\n                                    </label>\n                                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                </li>\n                                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                                <li class="item-divider">No unit found</li>\n                                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class="swiper-slide h-100 bg-color-white">\n                    <div class="toolbar toolbar-bottom padding-horizontal no-hairline bg-color-white">\n                        <div class="toolbar-inner">\n                            <a @click="prevSlide" class="button button-large display-flex align-items-center justify-content-center" href="#"><i class="icon material-icons">arrow_back</i></a>\n\n                            <a @click="nextSlide" id="request-confirm-problem"\n                               class="disabled border-rounded flex-grow-1 button button-fill button-large display-flex align-items-center justify-content-center" href="#">\n                                ';
      r += Template7Helpers.translate.call(ctx_1, "NEXT", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <i class="icon material-icons">arrow_forward</i>\n                            </a>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                    <div class="block">\n                        <h1 class="font-weight-bold no-margin-bottom" style="font-size: 2.3em;">\n                            ';
      r += Template7Helpers.translate.call(ctx_1, "What's the issue?", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </h1>\n                        <h3 class="no-margin-top font-weight-regular text-color-gray">\n                        </h3>\n                    </div>\n                    <div class="list accordion-list no-hairlines no-hairlines-between">\n                        <ul>\n                            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.problems, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <li>\n                                <label class="item-checkbox item-content">\n                                    <input data-label="';
          r += c(ctx_2.name, ctx_2);
          r += '" name="problem_id" type="radio" value="';
          r += c(ctx_2.id, ctx_2);
          r += '"/>\n                                    <i class="icon icon-checkbox"></i>\n                                    <div class="item-inner">\n                                        <div class="item-title">\n                                            ';
          r += Template7Helpers.translate.call(ctx_2, ctx_2.name, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                        </div>\n                                    </div>\n                                </label>\n                            </li>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <li class="item-divider">Select unit first</li>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            ';
      r += Template7Helpers.js_if.call(ctx_1, "Object.keys(this.problems).length > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <li>\n                                <label class="item-checkbox item-content">\n                                    <input data-label="Other" name="problem_id" type="radio" value="-1"/>\n                                    <i class="icon icon-checkbox"></i>\n                                    <div class="item-inner">\n                                        <div class="item-title">\n                                            ';
          r += Template7Helpers.translate.call(ctx_2, "Tell us what's happening", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                        </div>\n                                    </div>\n                                </label>\n                            </li>\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.problem, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            ';
          r += Template7Helpers.js_if.call(ctx_2, "this.problem.id == -1", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <li class="item-content item-input item-input-with-info">\n                                <div class="item-inner">\n                                    <!--                            <div class="item-title item-label">Describe your problem</div>-->\n                                    <div class="item-input-wrap padding-horizontal border-rounded-20" style="box-sizing: border-box;border: 1px solid #eaeaea">\n                                        <input id="request-other-problem" name="problem_input" placeholder=\'';
              r += Template7Helpers.translate.call(ctx_3, "Briefly describe your problem", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\' required\n                                               type="text" validate>\n                                        <span class="input-clear-button" style="right: 10px;"></span>\n                                    </div>\n                                </div>\n                            </li>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </ul>\n                    </div>\n                </div>\n                </div>\n                <div class="swiper-slide h-100 bg-color-white">\n                    <div class="toolbar toolbar-bottom padding-horizontal no-hairline bg-color-white">\n                        <div class="toolbar-inner">\n                            <a @click="prevSlide" class="button button-large display-flex align-items-center justify-content-center" href="#"><i class="icon material-icons">arrow_back</i></a>\n                            ';
      r += Template7Helpers.js_if.call(ctx_1, " !this.location || !this.unit || !this.problem || !this.when", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <a class="disabled flex-grow-1 button button-fill button-large display-flex align-items-center justify-content-center" href="#">\n                                ';
          r += Template7Helpers.translate.call(ctx_2, "Submit Request", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </a>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <a @click="requestRepair" id="submit-request"\n                               class="flex-grow-1 border-rounded button button-fill button-large display-flex align-items-center justify-content-center" href="#">\n                                ';
          r += Template7Helpers.translate.call(ctx_2, "Submit Request", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            </a>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </div>\n                    </div>\n                    <div class="page-content">\n                    <div class="block">\n                        <h1 class="font-weight-bold no-margin-bottom" style="font-size: 2.3em;">\n                            ';
      r += Template7Helpers.translate.call(ctx_1, "When do you need support?", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </h1>\n                        <h3 class="no-margin-top font-weight-regular text-color-gray">\n                        </h3>\n                    </div>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.show_contract_reminder, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="list media-list no-hairlines">\n                            <ul>\n                                <li>\n                                    <div class="item-content">\n                                        <div class="item-media" style="align-self: center">\n                                            <i class="icon material-icons text-color-primary">info_circle</i>\n                                        </div>\n                                        <div class="item-inner">\n                                            <div class="item-title-row">\n                                                <div class="item-title" style="font-size: 16px"><strong class="text-color-primary">\n                                                    ';
          r += Template7Helpers.translate.call(ctx_2, "Contract Terms", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</strong></div>\n                                            </div>\n                                            <div class="item-content no-padding" style="min-height: auto;font-size: 14px; color:#666;">';
          r += Template7Helpers.if.call(ctx_2, ctx_2.unit, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += c(ctx_3.unit.contract.material_label, ctx_3);
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>\n                                        </div>\n                                    </div>\n                                </li>\n                            </ul>\n                        </div>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    <div class="list accordion-list no-hairlines no-hairlines-between">\n                        <ul>\n                            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.whens, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <li>\n                                <label class="item-checkbox item-content">\n                                    <input data-label="';
          r += c(ctx_2.name, ctx_2);
          r += '" id="when-';
          r += c(ctx_2.id, ctx_2);
          r += '" name="schedule" type="radio"\n                                           value="';
          r += c(ctx_2.id, ctx_2);
          r += '"/>\n                                    <i class="icon icon-checkbox"></i>\n                                    <div class="item-inner">\n                                        <div class="item-title">\n                                            ';
          r += Template7Helpers.translate.call(ctx_2, ctx_2.name, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                            <div class="item-footer">\n                                                ';
          r += Template7Helpers.translate.call(ctx_2, ctx_2.description, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                                            </div>\n                                        </div>\n                                    </div>\n                                </label>\n                            </li>\n                            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            <li class="item-divider">No unit selected</li>\n                            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.when, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                            ';
          r += Template7Helpers.js_if.call(ctx_2, "this.when.id == 30", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <li>\n                                <div class="item-content item-input">\n                                    <div class="item-inner">\n                                        <div class="item-input-wrap padding-horizontal border-rounded-20" style="box-sizing: border-box;border: 1px solid #eaeaea">\n                                            <input id="scheduled-calendar-date-time" name="scheduled_at" placeholder=\'';
              r += Template7Helpers.translate.call(ctx_3, "Select date and time", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\'\n                                                   readonly="readonly" type="text"/>\n                                        </div>\n                                    </div>\n                                </div>\n                            </li>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        </ul>\n                    </div>\n                </div>\n                </div>\n            </div>\n            <div class="swiper-pagination"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    